import styles from './styles.module.scss';
import dayjs from 'dayjs';
import { DateLlFormat } from '../../constants/data';

const FieldsMarker = ({ t, text, fieldName, date }) => {
  return (
    <div className={styles.marker}>
      <div className={styles.markerSubtitle}>{fieldName || t('empty.noName')}</div>
      {text && <div className={styles.markerText}>{text.replace(/_/g, ' ')}</div>}
      {date && <time className={styles.markerDate}>{dayjs(date).format(DateLlFormat)}</time>}
    </div>
  );
};

export default FieldsMarker;
